import Vue from 'vue';
import VueVirtualScroller from 'vue-virtual-scroller'

Vue.use(VueVirtualScroller);
